import useRequest from "@/utils/useCrypRequest"
// /quan/h5/config/article/content/query

// 查询文章
export const queryArticle = (params:{code:string}) => {
    return useRequest.get(
    '/quan/h5/config/article/content/query',
    params,
      {
        params,
        transform(result) {
          return result.data||{}
        },
      }
    )
  }